import Constants from '../../config.local.js'
import Horse from '@/mixins/Horse'
import PlanningScheduleTransformer from '@/assets/js/dexie/transformers/PlanningScheduleTransformer.js'
import SeasonTransformer from '@/assets/js/dexie/transformers/SeasonTransformer.js'
import Common from '@/assets/js/common'

var PlanningMonte = {
	mixins: [Horse],

    methods: {

    	async getCurrentSeason(date) {
			if(!this.$storage.db.season) {
				return []
			}

			date.setHours(0,0,0,0);

    		return await this.$storage.db.t('season')
            .then(table => {
                return table.toCollection()
                .filter(season => (season.season_start <= date && season.season_end >= date))
            })
            .then(col => {
                return col.transform(new SeasonTransformer())
            })
    	},

		getPlanningInfoByMare: async function(mare_id) {
        	const url = this.constructRoute(Constants.PLANNING_MONTE_BY_MARE, { mare_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("PlanningMonteMixin::getPlanningInfoByMare", url)
			.then(res => {
				return res.retour
			})
			.catch(error => {
				console.error("PlanningMonteMixin::getPlanningInfoByMare => ERROR", error)
				return []
			})
        },

    	async getSchedulesByStallionMainOnline(stallion_id, date) {
			const url = this.constructRoute(Constants.PLANNING_SCHEDULE_STALLION_DATE, {stallion_id, date: date.toDateInputValue()}) + "?licence_key="+Constants.USER_LICENCE_KEY
			return this.$request.request_get_api("PlanningMonteMixin::getSchedulesByStallionMainOnline", url)
				.catch(e => {
					console.error("PlanningMonteMixin::getSchedulesByStallionMainOnline => ", e)
					return null
				})
				.then(res => res.retour)
    	},

    	async deleteScheduleOnline(type, schedulehorse_id) {
    		let url = this.constructRoute(Constants.PLANNING_MONTE_EDIT_SCHEDULE, {type, schedulehorse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

			const response = await this.$request.request_delete_api("PlanningMonteMixin::deleteScheduleOnline", url)
			.catch(e => {
				console.log(e);
				console.error("PlanningMonteMixin::deleteScheduleOnline", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

			return response
    	},


    	async getResidencePlanningDefault(season_id, type) {
			const url = this.constructRoute(Constants.PLANNING_MONTE_DEFAULT, {type, season_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

			return this.$request.request_get_api("PlanningMonteMixin::getResidencePlanningDefault", url)
				.catch(e => {
					console.error("PlanningMonteMixin::getResidencePlanningDefault => ", e)
					return null
				})
				.then(res => res ? res.retour : null)
    	},

		async getPlanningOnline(season_id, type, date_planning, lieu_id) {
			const date = date_planning.toDateInputValue()
			const url = this.constructRoute(Constants.PLANNING_MONTE_BY_SEASON_AND_LIEU, {season_id, type, date, lieu_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			return this.$request.request_get_api("PlanningMonteMixin::getPlanningOnline", url)
				.catch(e => {
					console.error("PlanningMonteMixin::getPlanningOnline => ", e)
					return null
				})
				.then(res => res.retour)
		},

    	async saveScheduleHorseOnline(type, stallion_id, schedule_id, mare_id, contact_id, date, schedulehorse_id, commentaire, tiers_id, commentaire_color) {
    		let url = this.constructRoute(Constants.PLANNING_MONTE_ADD_SCHEDULE, {type}) + "?licence_key="+Constants.USER_LICENCE_KEY
    		if(schedulehorse_id) {
    			url = this.constructRoute(Constants.PLANNING_MONTE_EDIT_SCHEDULE, {type, schedulehorse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
    		}

    		const params = {stallion_id, mare_id, contact_id, date, schedule_id, commentaire, commentaire_color: commentaire_color || null, tiers_id}

			const response = await this.$request.request_post_api("PlanningMonteMixin::saveScheduleHorseOnline", url, params, false)
			.catch(e => {
				console.log(e);
				console.error("PlanningMonteMixin::saveScheduleHorseOnline", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

			return response.retour
    	},

		async getMareContext(mare_id, season_id) {
			const url = this.constructRoute(Constants.CONTRACT_MARE_CONTEXT_URL, { mare_id, season_id }) + '?licence_key=' + Constants.USER_LICENCE_KEY
			const res = await this.$request.request_get_api('PlanningMonteMixin::getMareContext', url)
				.catch(e => {
					console.error('PlanningMonteMixin::getMareContext', e)
					return null
				})
			return (res && res.retour) ? res.retour : null
		},

    	async savePlanningComment(comment, commentaire_color, lieu, date) {
    		let url = Constants.PLANNING_MONTE_COMMENTAIRE+"?licence_key="+Constants.USER_LICENCE_KEY
			const params = {'commentaire':comment, 'commentaire_color': commentaire_color || null, 'lieu':lieu, 'date':date}
			const response = await this.$request.request_post_api("PlanningMonteMixin::savePlanningComment", url, params, false)
			.catch(e => {
				console.log(e);
				console.error("PlanningMonteMixin::savePlanningComment", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

			return response.retour
    	},


    	async getPlanningComment(lieu, date) {
    		let url = Constants.PLANNING_MONTE_COMMENTAIRE+"?licence_key="+Constants.USER_LICENCE_KEY+"&date="+date+"&lieu="+lieu
			const response = await this.$request.request_get_api("PlanningMonteMixin::getPlanningComment", url)
			.catch(e => {
				console.log(e);
				console.error("PlanningMonteMixin::getPlanningComment", e)
				this.failureToast("toast.info_save_failed")
				return null
			})

			return response.retour
    	},

    	 async printPlanning(season_id, type, lieu_id, date_start, date_end, only_active = false) {
            const url = this.constructRoute(Constants.PLANNING_MONTE_PRINT, {season_id, type, lieu_id, date_start, date_end}) + "?licence_key="+Constants.USER_LICENCE_KEY+"&only_active="+only_active
            const result = await this.$request.request_get_api("ResultatAnalyse::printPlanning", url)
            .catch(error => {
                console.error("ResultatAnalyse::printPlanning => ERROR", error)
                return null
            })
            Common.base64ToPdf(result, "planning_"+type+".pdf")
            return true
        },

    	 async printPlanningDay(season_id, type, lieu_id, date, commentaire, only_active = false) {
            const url = this.constructRoute(Constants.PLANNING_MONTE_PRINT_DAY, {season_id, type, lieu_id, date}) + "?licence_key="+Constants.USER_LICENCE_KEY+"&only_active="+only_active+"&commentaire="+encodeURIComponent(commentaire || '')
            const result = await this.$request.request_get_api("ResultatAnalyse::printPlanning", url)
            .catch(error => {
                console.error("ResultatAnalyse::printPlanning => ERROR", error)
                return null
            })
            Common.base64ToPdf(result, "planning_"+type+".pdf")
            return true
        },

		async printDayFeuilleSaillie(season_id, type, lieu_id, date, model_id, creneaux_ids) {
			const params = {model_id, creneaux_ids}

            const url = this.constructRoute(Constants.PLANNING_MONTE_PRINT_FEUILLE, {season_id, type, lieu_id, date}) + "?licence_key="+Constants.USER_LICENCE_KEY
            const result = await this.$request.request_post_api("PlanningMonteMixin::printDayFeuilleSaillie", url, params, false)
            .catch(error => {
                console.error("PlanningMonteMixin::printDayFeuilleSaillie => ERROR", error)
                return null
            })
            Common.base64ToPdf(result, "feuille_saillie_"+type+".pdf")
            return true
        },

		async getPlanningConfigOnline(season_id, type, lieu_id) {
			const url = this.constructRoute(Constants.PLANNING_MONTE_CONFIG, { type, season_id, lieu_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY + "&lieu_id=" + lieu_id
			const response = await this.$request.request_get_api("PlanningMonteMixin::getPlanningConfigOnline", url)
				.catch(e => {
					console.error("PlanningMonteMixin::getPlanningConfigOnline", e)
					return null
				})
			return (response && response.retour) ? response.retour : null
		},

		async savePlanningConfigOnline(season_id, type, lieu_id, schedules, stallions, planning_default) {
			const url = this.constructRoute(Constants.PLANNING_MONTE_CONFIG, { type, season_id, lieu_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY
			const params = { schedules, stallions, default: planning_default, licence_key: Constants.USER_LICENCE_KEY }
			const response = await this.$request.request_post_api("PlanningMonteMixin::savePlanningConfigOnline", url, params, false)
				.catch(e => {
					console.error("PlanningMonteMixin::savePlanningConfigOnline", e)
					this.failureToast("toast.info_save_failed")
					return null
				})
			return (response && response.retour) ? response.retour : null
		},
	}
}

export default PlanningMonte
